import { css } from '@emotion/react'

export const styles = {
  content: css`
    margin-left: 76px;
    min-height: 100vh;
    background-image: url(${require('./assets/background.svg')});
  `,
}
